import { gql } from '@apollo/client'

const GET_MEMBER_MERCHANT_BY_ID = gql`
  query getMerchant($merchantId: uuid!) {
    merchants_by_pk(id: $merchantId) {
      id
      name
      description
      slug
      setting
      vehicles
      pre_order_vehicles
      transaction_plan_id
      app_setting {
        id
        enabled
        google_play_url
        apple_store_url
      }
      integration_settings
      registered_company_name
      subscription
      has_onboarded
      dispatch_selfserve_enabled
      is_seo_enabled
      loyalty_scan_method
      loyalty_implementation
      stripe_settings {
        stripe_user_id
      }
      current_plan
      price_matrices(where: { archived_at: { _is_null: true } }) {
        id
        name
        data
        global
        stores {
          slug
        }
      }
    }
  }
`

const GET_MERCHANT_BY_ID = gql`
  query getMerchant($merchantId: uuid!) {
    merchants_by_pk(id: $merchantId) {
      id
      name
      description
      add_to_wallet_enabled
      slug
      setting
      vehicles
      pre_order_vehicles
      trust_pilot_email
      cro_registered_number
      transaction_plan_id
      app_setting {
        id
        enabled
        google_play_url
        apple_store_url
      }
      integration_settings
      registered_company_name
      subscription
      has_onboarded
      dispatch_selfserve_enabled
      is_seo_enabled
      loyalty_scan_method
      loyalty_implementation
      stripe_settings {
        stripe_user_id
      }
      address {
        merchant_id
        contact_num
        line_1
        line_2
        city
        country
        zip
        geom
      }
      current_plan
      zero_order_rate_id
      price_matrices(where: { archived_at: { _is_null: true } }) {
        id
        name
        data
        global
        stores {
          slug
        }
      }
    }
  }
`

const QUERY_MERCHANT_LOCATIONS = gql`
  query queryMerchantLocations($slug: String!) {
    merchants(where: { slug: { _eq: $slug } }) {
      stores {
        address {
          id
          geom
          line_1
          line_2
          city
          zip
        }
        email
        name
        slug
        is_open
        exclude_from_listings
        inserted_at
        archived_at
        id
        settings
        schedules
        pre_order_settings {
          pickup_enabled
          delivery_enabled
        }
        store_order_type_settings {
          order_type
          fulfillment_type
          auto_accept
        }
      }
    }
  }
`

const GET_STORES_BY_ID = gql`
  query getStores($storeIds: [uuid!]) {
    stores(where: { id: { _in: $storeIds } }) {
      id
      name
    }
  }
`

// Loaders that only need to resolve the route slug to a store id use this
// rather than QUERY_MERCHANT_STORES, which pulls the store's entire settings,
// address, users and pre-order blocks for a single field.
const QUERY_STORE_ID_BY_SLUG = gql`
  query getStoreIdBySlug($slug: String!) {
    stores(where: { slug: { _eq: $slug } }) {
      id
    }
  }
`

const GET_MERCHANT_CATEGORIES = gql`
  query getMerchantCategories($merchantId: uuid!) {
    categories(
      where: { merchant_id: { _eq: $merchantId } }
      order_by: { name: asc }
    ) {
      id
      name
      slug
      description
      archived_at
      capacity_weight
      products_categories(
        where: { product: { archived_at: { _is_null: true } } }
      ) {
        id
      }
      category_special_availabilities {
        special_availability {
          id
          end_time
          end_datetime
          rrule
          order_type
          store_special_availabilities {
            store {
              id
              slug
            }
          }
        }
      }
    }
  }
`

const GET_MERCHANT_INTEGRATIONS = gql`
  query getMerchantPartners($merchantId: uuid!) {
    partners_merchants(where: { merchant_id: { _eq: $merchantId } }) {
      partner {
        name
      }
    }
  }
`

const QUERY_STRIPE_CONNECT_URL = gql`
  query stripeConnect($redirectUri: String, $merchantId: String) {
    stripeConnectUrl(redirectUri: $redirectUri, merchantId: $merchantId) {
      url
      hasConnected
      type
      login_link
      hasOnboarded
    }
  }
`

const FETCH_LIGHTSPEED_LOCATIONS = gql`
  query FetchLightspeedIds {
    fetchLightspeedIds {
      id
      name
      businessLocations {
        id
        name
      }
    }
  }
`

const GET_LIGHTSPEED_STORES = gql`
  query getLightspeedStores($merchantId: uuid!) {
    stores(where: { merchant_id: { _eq: $merchantId } }) {
      id
      name
      store_integration_settings {
        lightspeed_menus
        lightspeed_business_id
        lightspeed_business_name
        lightspeed_business_location_id
        lightspeed_business_location_name
        lightspeed_order_profile_mapping
        lightspeed_last_menu_push_at
        lightspeed_scheduled_order_buffer_sameday_minutes
        lightspeed_scheduled_order_buffer_preorder_minutes
      }
    }
  }
`

const LIST_INTEGRATIONS = gql`
  query listIntegrations($merchant_id: uuid!, $provider: String) {
    listIntegrations(merchant_id: $merchant_id, provider: $provider) {
      id
      webhook_token
      location_ids
    }
  }
`

export {
  GET_MEMBER_MERCHANT_BY_ID,
  GET_MERCHANT_BY_ID,
  GET_STORES_BY_ID,
  QUERY_MERCHANT_LOCATIONS,
  QUERY_STORE_ID_BY_SLUG,
  GET_MERCHANT_CATEGORIES,
  GET_MERCHANT_INTEGRATIONS,
  QUERY_STRIPE_CONNECT_URL,
  FETCH_LIGHTSPEED_LOCATIONS,
  GET_LIGHTSPEED_STORES,
  LIST_INTEGRATIONS
}
